import React, { createContext, useContext, useState, useCallback } from 'react';
import { PiCheckCircle, PiWarningCircle, PiInfo, PiX } from 'react-icons/pi';
import './Toast.css';

const ToastContext = createContext(null);

export function useToast() {
    return useContext(ToastContext);
}

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter(t => t.id !== id));
    }, []);

    const addToast = useCallback((message, type = 'success') => {
        const id = Date.now().toString() + Math.random().toString();
        setToasts((prev) => [...prev, { id, message, type }]);
        setTimeout(() => {
            removeToast(id);
        }, 4000);
    }, [removeToast]);

    return (
        <ToastContext.Provider value={{ addToast }}>
            {children}
            <div className="toast-container" aria-live="polite">
                {toasts.map((toast) => (
                    <div key={toast.id} className={`toast toast-${toast.type}`}>
                        <div className="toast-icon">
                            {toast.type === 'success' && <PiCheckCircle size={20} />}
                            {toast.type === 'error' && <PiWarningCircle size={20} />}
                            {toast.type === 'info' && <PiInfo size={20} />}
                        </div>
                        <p className="toast-message">{toast.message}</p>
                        <button className="toast-close" onClick={() => removeToast(toast.id)} aria-label="Close">
                            <PiX size={16} />
                        </button>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
}
